/**
 * The CATALOGUE slice of the Admin surface — ONE route since the merge (roles/products
 * design §2.1, owner ruling 2026-08-11).
 *
 * ⚠ `admin/catalogue` STOOD HERE AND IS RETIRED WITH ITS SCREEN. The former Product
 * master (`admin/products`) and Catalogue pricing (`admin/catalogue`) merged into the one
 * `ProductsPage`; a second path answering the old screen would be a live route with no
 * nav entry — exactly the dead-surface shape the go-live retirement (tax-groups §6, G2)
 * removed, from the other side. The nav entry retires in the same change
 * (`domain/nav.ts`), and `products-page.test.tsx` pins both stay gone.
 *
 * Named `routes.catalogue.tsx` for the reason `routes.infra.tsx` records — one route
 * array per work stream, meeting only in `src/routes.extra.ts`. Mounts INSIDE
 * `RequireCountry` + `AppShell` under `/countries/:cc/admin/…`: the `:cc` is load-bearing
 * for a Country Admin (it decides WHICH catalogue) and scopes only the chrome for a group
 * admin's cross-country view.
 */

import type { RouteObject } from 'react-router-dom';
import { ProductsPage } from './ProductsPage';

export const adminCatalogueRoutes: RouteObject[] = [
  { path: 'admin/products', element: <ProductsPage /> },
];
